import http from '../../app/services/httpServices';
import URL_UTILITY from '../../app/utility/url.utility';

const getTwoSixASInvoiceList = (context, payload) => {
  const url = URL_UTILITY.getTwoSixASInvoiceUrl;
  return http.getApi(url, payload);
};

const getTwoSixASInvoiceDetailsById = (context, customerTrxNumber) => {
  return http.getApi(
    URL_UTILITY.getTwoSixASInvoiceUrl +
      'LineDtls?customerTrxNumber=' +
      customerTrxNumber
  );
};

const getTwoSixASChargeDetailsById = (context, customerTrxNumber) => {
  return http.getApi(
    URL_UTILITY.getTwoSixASInvoiceUrl +
      'ChbkDtls?customerTrxNumber=' +
      customerTrxNumber
  );
};

const getPeriodStartList = (context, payload) => {
  const url = URL_UTILITY.getPeriodStartListUrl;
  return http.getApi(
    url +
      '?qtr=' +
      payload.qtr +
      '&fy_start_date=' +
      payload.fy_start_date +
      '&fy_end_date=' +
      payload.fy_end_date
  );
};

const addUploadExcelList = (context, payload) => {
  const url = URL_UTILITY.addUploadExcelListUrl;
  return http.postApi(url, payload);
};

const getFinYearList = () => {
  const url = URL_UTILITY.getFinYearListUrl;
  return http.getApi(url);
};

const getPanNumForTwoSixUpload = (context, payload) => {
  const url = URL_UTILITY.getPanNumForTwoSixUploadUrl;
  return http.getApi(url + '?le_id=' + payload);
};

const getMappingColumnsForExcelDetail = (context, payload) => {
  const url = URL_UTILITY.getMappingColumnsForExcelDetailUrl;
  return http.getApi(url, payload);
};

const getMappingColumnsDataListForExcelDetail = (context, payload) => {
  const url = URL_UTILITY.getMappingColumnsDataListForExcelDetailUrl;
  return http.getApi(url, payload);
};

const getTempDataList = (context, payload) => {
  const url = URL_UTILITY.getTempDataUrl;
  return http.getApi(url, payload);
};

const postTempDataList = (context, payload) => {
  const url = URL_UTILITY.postTempDataUrl;
  return http.postApi(
    url +
      '?excel_import_hdr_id=' +
      payload.excel_import_hdr_id +
      '&menu_id=' +
      payload.menu_id +
      '&sub_menu_id=' +
      payload.sub_menu_id
  );
}



const getCustomerTanData = (context, payload) => {
  return http.getApi(URL_UTILITY.getCustomerTanDataUrl, payload);
};

const postTempDataExcel = (context, payload) => {
  const url = URL_UTILITY.postTempDataExcelUrl;
  return http.postApi(
    url +
      '?le_id=' +
      payload.le_id +
      '&pan_no=' +
      payload.pan_no +
      '&financial_start_date=' +
      payload.financial_start_date +
      '&financial_end_date=' +
      payload.financial_end_date +
      '&quarter=' +
      payload.quarter +
      '&period_start_date=' +
      payload.period_start_date +
      '&period_end_date=' +
      payload.period_end_date
  );
};

const getRowDataById = (context, payload) => {
  const url = URL_UTILITY.getRowDataByIdUrl;
  return http.getApi(url, payload);
};

const postMappedColumnsForExcel = (context, payload) => {
  const url = URL_UTILITY.postMappedColumnsForExcelUrl;
  return http.postApi(url, payload);
};

const getTanRateDetails = (context, payload) => {
  return http.getApi(URL_UTILITY.getTanRateDetailsUrl, payload);
};

const getTwoSixASList = (context, payload) => {
  return http.getApi(URL_UTILITY.getTwoSixASListUrl + `?_page=${payload._page}&_limit=${payload._limit}&le_id=${payload.le_id}&pan_no=${payload.pan_no}&financial_start_date=${payload.financial_start_date}&financial_end_date=${payload.financial_end_date}`)
}
const postpanBankExcelData = (context, payload) => {
  return http.postApi(URL_UTILITY.postPanBankExcelDataUrl + `/excel-upload/${payload.excelImportId}/excel-upload`,payload);
};
const validatePanBankExcel = (context, payload) => {
  return http.getApi(URL_UTILITY.postPanBankExcelDataUrl + `/pan-verify-excel/${payload.excelImportId}`)
}
const getPankBankExcelData = (context, payload) => {
  return http.getApi(URL_UTILITY.postPanBankExcelDataUrl + `/pan-verify-excel-data`,payload)
}
const downloadpanBankVerifiedExcel = (context, payload) => {
  return http.getApi(URL_UTILITY.postPanBankExcelDataUrl + `/excel-download/${payload.excelImportId}`,payload)
};
 // 1.1 (Himanshu) MSME data
const msmeData = (context, payload) => {
  return http.postApi(URL_UTILITY.getExcelUploadedData + `/saveDataTmp?excel_import_hdr_id=${payload.excelImportId}&menu_id=${payload.menu_id}&sub_menu_id=${payload.sub_menu_id}`);
};
 // 1.1 (Himanshu) MSME data
const validateMsmeExcel = (context, payload) => {
  return http.getApi(URL_UTILITY.getVendorBankUpdateUrl + `/msme-verify-excel/${payload.excelImportId}`)
};
 // 1.1 (Himanshu) MSME data
const downloadMsmeVerifiedExcel = (context, payload) => {
  return http.getApi(URL_UTILITY.getVendorBankUpdateUrl + `/msme-verify-excel-download/${payload.excelImportId}`,payload)
};
 // 1.1 (Himanshu) MSME data
const getMsmeVerifiedExcelData = (context, payload) => {
  return http.getApi(URL_UTILITY.getVendorBankUpdateUrl + `/msme-verify-excel-data`,payload)
};


export default {
  getTwoSixASInvoiceList,
  getTwoSixASInvoiceDetailsById,
  getTwoSixASChargeDetailsById,
  getPeriodStartList,
  getFinYearList,
  getPanNumForTwoSixUpload,
  addUploadExcelList,
  getMappingColumnsForExcelDetail,
  getMappingColumnsDataListForExcelDetail,
  postMappedColumnsForExcel,
  getTempDataList,
  postTempDataExcel,
  getRowDataById,
  getCustomerTanData,
  getTanRateDetails,
  getTwoSixASList,
  postTempDataList,
  postpanBankExcelData,
  validatePanBankExcel,
  getPankBankExcelData,
  downloadpanBankVerifiedExcel,
  msmeData,
  validateMsmeExcel,
  downloadMsmeVerifiedExcel,
  getMsmeVerifiedExcelData
  };
